import React, { useState, useEffect, useRef } from "react";
import InView from "react-intersection-observer";
import { SlideInWithScroll } from "../common/utils/animations/slideInWithScroll";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion } from "framer-motion";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

function CareerServicesObj(props) {
  const { title, header, content, gridItems, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);

  const triggers = [[1, 0.85], [0.9, 0.75], [0.8, 0.65], [1, 0.85], [0.9, 0.75], [0.8, 0.65],];
  return (
    <InView as="div" onChange={(inView) => setIsVisible(inView)} className="career-services section-gap" id="career-services">
      <div className={`page-intro-section section-gap-small ${classes}`} id="activities">
        <div className="container">
          <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
          <h2 className="h3">{header}</h2>
          {content}
        </div>
      </div>

      <div className="grid-layout-section-style-2">
        <div className="container">
          <div className="row d-flex flex-wrap">
            {gridItems && gridItems.map((item, index) => {
              return (<Parallax classes="col grid-item-style-2" key={index} id={"career-grid-item-" + index} direction={directions.LTR} length={50} opacity={true} triggers={triggers[index]}>
                <div className="item-inner text-center">
                  <div className="grid-icon-center">
                    <i className="icon-small">{item.icon}</i>
                  </div>
                  <h3>{item.header}</h3>
                  <p>{item.content}</p>
                </div>
              </Parallax>);
              //return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[index], triggers[index + 2]]} key={index} />;
            })}
          </div>
        </div>
      </div>

    </InView>
  );
};

export default CareerServicesObj;